<div>
  <img [src]="imageUrl" class="img-fluid" alt="Responsive image" (click)="openImageInNewWindow()">
</div>
